<ui-modal-window (closeButtonClick)="close()">
  <div class="about">
    <div class="about__logo">
      <img
        ngSrc="./assets/aclara-logo-horizontal.svg"
        width="218"
        height="48"
        alt="Aclara"
        priority
      />
    </div>
    @if (versions$ | async; as versions) {
      <div class="about__card">
        <div class="about__row">
          <span class="about__label">{{ deviceGatewayLabel | translate }}</span>
          <span class="about__value">{{ versions.deviceGateway }}</span>
        </div>
        <div class="about__divider"></div>
        <div class="about__row">
          <span class="about__label">{{ analyticsPlatformLabel | translate }}</span>
          <span class="about__value">{{ versions.analyticsPlatform }}</span>
        </div>
      </div>
    }
    <!-- Will be immplemented soon -->
    <!-- <div class="about__cta">
      <a
        class="about__link"
        [href]="releaseNotesLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ releaseNotesText | translate }}
        <ui-icon
          [name]="'open-link'"
          [size]="linkIconSize"
          [color]="linkColor"
        ></ui-icon>
      </a>
    </div> -->
  </div>
</ui-modal-window>
